const initState = {
  tasks: [
    {
      id: 1,
      title: "good month",
      content: "bla bla bla bal",
    },
    {
      id: 2,
      title: "bad month",
      content: "bla bla bla bal",
    },
    {
      id: 3,
      title: "boring month",
      content: "bla bla bla bal",
    },
  ],
};

const taskReducer = (state = initState, action) => {
  switch (action.type) {
    case "CREATE_TASK":
      console.log("created task", action);
      return state;
    case "NEW_TASK_ERROR":
      console.log("new task error", action.err);
      return state;

    default:
      return state;
  }
};

export default taskReducer;
